import { render, staticRenderFns } from "./senceConfig.vue?vue&type=template&id=a6b1670c&scoped=true&"
import script from "./senceConfig.vue?vue&type=script&lang=js&"
export * from "./senceConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b1670c",
  null
  
)

export default component.exports